// ============================================================
// User Management API — /api/v1/users, /api/v1/user
// ============================================================

import { apiGet, apiPost, apiPut, apiDelete, unwrap } from './apiClient';
import {
  ResponseDTO,
  UserManagementDTO,
  UpdatePasswordDTO,
  AssignRolesRequestDTO,
  RemoveRolesRequestDTO,
} from '@/types/api';

const opts = { includeTenantHeader: true } as const;

// POST /api/v1/users — create a new user
export async function createUser(body: UserManagementDTO): Promise<UserManagementDTO> {
  const res = await apiPost<ResponseDTO<UserManagementDTO>>('/api/v1/users', body, opts);
  return unwrap(res);
}

// PUT /api/v1/users — update an existing user
export async function updateUser(body: UserManagementDTO): Promise<UserManagementDTO> {
  const res = await apiPut<ResponseDTO<UserManagementDTO>>('/api/v1/users', body, opts);
  return unwrap(res);
}

// GET /api/v1/users — list all users
export async function listUsers(): Promise<UserManagementDTO[]> {
  const res = await apiGet<ResponseDTO<UserManagementDTO[]>>('/api/v1/users', opts);
  return unwrap(res);
}

// GET /api/v1/user?email= — get a single user by email
export async function getUserByEmail(email: string): Promise<UserManagementDTO> {
  const res = await apiGet<ResponseDTO<UserManagementDTO>>('/api/v1/user', {
    ...opts,
    params: { email },
  });
  return unwrap(res);
}

// DELETE /api/v1/user?email= — delete a user by email
export async function deleteUser(email: string): Promise<void> {
  await apiDelete<ResponseDTO<void>>('/api/v1/user', undefined, {
    ...opts,
    params: { email },
  });
}

// PATCH /api/v1/user/update-password
export async function updatePassword(body: UpdatePasswordDTO): Promise<void> {
  await apiPost<ResponseDTO<void>>('/api/v1/user/update-password', body, {
    ...opts,
    method: 'PATCH',
  } as any);
}

// POST /api/v1/user/assign-roles
export async function assignRoles(body: AssignRolesRequestDTO): Promise<void> {
  await apiPost<ResponseDTO<void>>('/api/v1/user/assign-roles', body, opts);
}

// POST /api/v1/user/remove-roles
export async function removeRoles(body: RemoveRolesRequestDTO): Promise<void> {
  await apiPost<ResponseDTO<void>>('/api/v1/user/remove-roles', body, opts);
}
